<template>
  <div>
    <h1 class="page-header">Customer Profiles</h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-group row m-b-15">
                <label class="col-md-5 col-form-label control-label">Name <span class="text-danger">*</span> </label>
                <div class="col-md-7">
                  <input
                    ref="customer_name"
                    v-model="model.customer_name"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('customer_name') }"
                    placeholder="Enter name"
                  />
                  <div class="invalid-feedback" v-if="errors.has('customer_name')">
                    {{ errors.first('customer_name') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-15">
                <label class="col-md-5 col-form-label control-label ">Gender <span class="text-danger">*</span> </label>
                <div class="col-md-7">
                  <div class="radio radio-css radio-inline" :class="{ 'is-invalid': errors.has('gender') }">
                    <input type="radio" v-model="model.gender" value="Male" id="male" />
                    <label for="male">Male</label>
                  </div>
                  <div class="radio radio-css radio-inline" :class="{ 'is-invalid': errors.has('gender') }">
                    <input
                      :class="{ 'is-invalid': errors.has('gender') }"
                      type="radio"
                      v-model="model.gender"
                      value="Female"
                      id="female"
                    />
                    <label for="female">Female</label>
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label"> Contact No <span class="text-danger">*</span> </label>
                <div class="col-md-7">
                  <input
                    v-model="model.contact_no"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('contact_no') }"
                    placeholder="Enter contact no"
                  />
                  <div class="invalid-feedback" v-if="errors.has('contact_no')">
                    {{ errors.first('contact_no') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label">Email</label>
                <div class="col-md-7">
                  <input
                    v-model="model.email"
                    type="email"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('email') }"
                    placeholder="Enter Email address"
                  />
                  <div class="invalid-feedback" v-if="errors.has('email')">
                    {{ errors.first('email') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label">Description</label>
                <div class="col-md-7">
                  <textarea
                    v-model.trim="model.description"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('description') }"
                    rows="3"
                    placeholder="Enter description"
                  ></textarea>
                  <div class="invalid-feedback" v-if="errors.has('description')">
                    {{ errors.first('description') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="row text-right">
            <div class="col-lg-12">
              <ts-button color="primary" :disabled="saving" :waiting="saving" @click="update">
                Update
              </ts-button>
              <ts-button class="ml-2" @click="$router.push({ name: 'customer-profile' })">
                Cancel
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import apiCustomerProfile from '@/api/administration/company'

export default {
  name: 'customer-profile-edit-form',
  beforeRouteEnter: async (to, from, next) => {
    let response = await apiCustomerProfile.find(to.params.id)
    to.params.editData = response.data
    next(vm => vm.setEditData())
  },
  props: ['editData'],
  data() {
    return {
      model: {
        customer_id: 0,
        customer_name: null,
        gender: null,
        contact_no: null,
        email: null,
        description: null
      },
      errors: new Errors(),
      saving: false
    }
  },
  mounted() {
    this.$refs.customer_name.focus()
  },
  methods: {
    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('administration/customerProfile/updateCustomerProfile', this.model)

        this.$toasted.success(response.message)
        this.$router.push('/customer-profiles')
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEditData() {
      this.model.customer_id = this.editData.customer_id
      this.model.customer_name = this.editData.customer_name
      this.model.gender = this.editData.gender
      this.model.contact_no = this.editData.contact_no
      this.model.email = this.editData.email
      this.model.description = this.editData.description
    }
  }
}
</script>
